import React, { useState, useRef, useEffect } from "react";
import {
  Nav,
  Navbar,
  Container,
  Tooltip,
  OverlayTrigger,
  Modal,
  Form,
  Dropdown,
  Button,
} from "react-bootstrap";
import { PiListFill } from "react-icons/pi";
import { useSelector } from "react-redux";
import { selectID } from "../../features/id/id";
import { selectWindowWidth } from "../../features/windowWidth/windowWidth";
import { selectLogin } from "../../features/login/login";
import { selectName } from "../../features/name/name";
import { selectGoogleLogin } from "../../features/googleLogin/googleLogin";
import { BiSolidUserCircle } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateName } from "../../features/name/name";
import { MdOutlineOpenInNew } from "react-icons/md";
import { updateLogin } from "../../features/login/login";
import { updateGoogleLogin } from "../../features/googleLogin/googleLogin";
import "bootstrap/dist/css/bootstrap.min.css";

const logout_url = process.env.REACT_APP_API_URL + "/oauth/logout";
const login_url = process.env.REACT_APP_API_URL + "/oauth/login";
const update_name_url = process.env.REACT_APP_API_URL + "/oauth/me";

const google_login_url = process.env.REACT_APP_API_URL + "/oauth/google/login";
const google_logout_url = process.env.REACT_APP_API_URL + "/oauth/google/logout";

function BSNavbar(props) {
  const [modifyName, setModifyName] = useState(false);
  const [newName, setNewName] = useState("");
  const id = useSelector(selectID);
  const windowWidth = useSelector(selectWindowWidth);
  const login = useSelector(selectLogin);
  const name = useSelector(selectName);
  const googleLogin = useSelector(selectGoogleLogin);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showCourseDropdown, setShowCourseDropdown] = useState(false);
  const [showProfessorDropdown, setShowProfessorDropdown] = useState(false);
  const [showLoginDropdown, setShowLoginDropdown] = useState(false);
  const courseDropdownRef = useRef(null);
  const professorDropdownRef = useRef(null);

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      虛擬名稱：{name}
    </Tooltip>
  );

  const clearAuthState = () => {
    console.log("before clear");
    dispatch(updateLogin(false));
    dispatch(updateGoogleLogin(false));
    localStorage.removeItem("jwtToken");
    localStorage.removeItem("googleToken");
  };

  const handleLogout = async (e) => {
    e.preventDefault();
    await fetch(logout_url, {
      method: "GET",
      credentials: "include",
    }).then(() => {
      clearAuthState();
      console.log("e3 logout successful");
      navigate("/");
    });
  };

  const handleGoogleLogout = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("googleToken"); 
    await fetch(google_logout_url, {
      method: "GET",
      credentials: "include",
      headers: {
        "Authorization": `Bearer ${token}`, 
      },
    }).then(() => {
      clearAuthState();
      console.log("google logout successful, token removed");
      navigate("/");
    });
  }

  const handleUpdateName = async () => {
    const token = localStorage.getItem("jwtToken"); 
    await fetch(update_name_url, {
      method: "PATCH",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify({ name: newName }),
    })
      .then((res) => {
        if (res.status === 400) {
          alert("改名失敗，名字已被使用。");
        } else {
          alert("改名成功！");
          dispatch(updateName(newName));
          setModifyName(false);
        }
      })
      .catch((err) => {
        alert("改名失敗，請洽管理員。錯誤訊息：" + err);
      });
  };

  const handleE3Login = () => {
    localStorage.removeItem('guestMode');
    // localStorage.removeItem('googleToken');
    // dispatch(updateGoogleLogin(false));
    window.location.href = login_url;
  };

  const handleGoogleLogin = () => {
    localStorage.removeItem('guestMode');
    // localStorage.removeItem("jwtToken");
    localStorage.removeItem("googleToken");
    window.location.href = google_login_url;
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        courseDropdownRef.current &&
        !courseDropdownRef.current.contains(event.target)
      ) {
        setShowCourseDropdown(false);
      }
      if (
        professorDropdownRef.current &&
        !professorDropdownRef.current.contains(event.target)
      ) {
        setShowProfessorDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Navbar
      expand="md"
      className="bg-body-tertiary"
      variant="light"
      style={{ background: props.bg || "white" }}
    >
      <Modal show={modifyName} onHide={() => setModifyName(false)}>
        <Modal.Header closeButton>
          <Modal.Title>修改名稱</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Control
            placeholder="新名稱"
            autoFocus
            onChange={(e) => setNewName(e.target.value)}
          />
          <Form.Text>
            名稱請避免不當文字，包括但不限於違法、宗教、政治、種族衝突、人身攻擊等等，若有違反規定者管理員會採取適當措施。
          </Form.Text>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={handleUpdateName}>
            確認
          </Button>
        </Modal.Footer>
      </Modal>
      <Container>
        <Navbar.Brand
          href="/home"
          style={{
            fontFamily: "papernote",
            paddingTop: "10px",
            fontSize: "25px",
          }}
        >
          NCTU+
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" style={{ border: "0" }}>
          <PiListFill />
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav style={{ width: "100%" }}>
            <Dropdown 
              as={Nav.Item}
              ref={courseDropdownRef}
              show={showCourseDropdown}
            >
              <Dropdown.Toggle 
                as={Nav.Link} 
                style={{ 
                  fontFamily: "Noto Sans TC", 
                  border: "none", 
                  boxShadow: "none"
                }}
                onClick={(e) => {
                  e.preventDefault();
                  setShowCourseDropdown((prev) => !prev);
                }}
              >
                課程心得
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item href="/comment">查看心得</Dropdown.Item>
                {login && <Dropdown.Item href="/new">新增心得</Dropdown.Item>}
                {login && <Dropdown.Item href="/my-comment">我的心得</Dropdown.Item>}
              </Dropdown.Menu>
            </Dropdown>
            <Dropdown 
              as={Nav.Item}
              ref={professorDropdownRef}
              show={showProfessorDropdown}
            >
              <Dropdown.Toggle 
                as={Nav.Link} 
                style={{ fontFamily: "Noto Sans TC" }}
                onClick={(e) => {
                  e.preventDefault(); // 阻止頁面跳轉
                  setShowProfessorDropdown((prev) => !prev);
                }}
              >
                指導教授心得
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item href="/professor/comment">查看心得</Dropdown.Item>
                {login && <Dropdown.Item href="/professor/new">新增心得</Dropdown.Item>}
                {login && <Dropdown.Item href="/professor/my-comment">我的心得</Dropdown.Item>}
                {/*<Dropdown.Item href="/professor/ranking">排行榜</Dropdown.Item>*/}
              </Dropdown.Menu>
            </Dropdown>
            {id === "110511004" && (
              <Nav.Link
                style={{ fontFamily: "Noto Sans TC" }}
                onClick={() => setModifyName(true)}
              >
                修改暱稱
              </Nav.Link>
            )}
            <Nav.Link href="/reflection" style={{ fontFamily: "Noto Sans TC" }}>
              開發者小記
            </Nav.Link>
            {/* <Nav.Link href="/chichat" style={{ fontFamily: "Noto Sans TC" }}>
              ChiChat
            </Nav.Link> */}
            <Nav.Link
              href="https://cjchang925.github.io/study-friend/edit"
              target="_blank"
              style={{ fontFamily: "Noto Sans TC", display: "flex", alignItems: "center" }}
            >
              StudyFriend
              <MdOutlineOpenInNew />
            </Nav.Link>
            {login && (
              <Nav.Link
                onClick={googleLogin ? handleGoogleLogout : handleLogout}
                style={{ fontFamily: "Noto Sans TC" }}
              >
                登出
              </Nav.Link>
            )}
            {windowWidth >= 768 && login && (
              <OverlayTrigger
                placement="left"
                delay={{ show: 100, hide: 100 }}
                overlay={renderTooltip}
              >
                <Nav.Item
                  className="d-flex align-items-center ms-auto"
                  style={{ fontSize: "20px" }}
                >
                  <BiSolidUserCircle size={25} className="me-1" />
                  {id}
                </Nav.Item>
              </OverlayTrigger>
            )}
            {login || (
              <Dropdown 
                as={Nav.Item}
                onMouseEnter={() => setShowLoginDropdown(true)}
                onMouseLeave={() => setShowLoginDropdown(false)}
                show={showLoginDropdown}
              >
              <Dropdown.Toggle as={Nav.Link} style={{ fontFamily: "Noto Sans TC" }}>
                登入
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={handleE3Login}>e3 登入</Dropdown.Item>
                <Dropdown.Item onClick={handleGoogleLogin}>Google 登入</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default BSNavbar;
